var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEdit2 = function SvgEdit2(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 1.12499C6.47349 1.0265 6.59042 0.948372 6.7191 0.895069C6.84779 0.841766 6.98571 0.814331 7.125 0.814331C7.26429 0.814331 7.40221 0.841766 7.5309 0.895069C7.65958 0.948372 7.77651 1.0265 7.875 1.12499C7.97349 1.22348 8.05162 1.34041 8.10492 1.46909C8.15823 1.59778 8.18566 1.7357 8.18566 1.87499C8.18566 2.01428 8.15823 2.1522 8.10492 2.28089C8.05162 2.40957 7.97349 2.5265 7.875 2.62499L2.8125 7.68749L0.75 8.24999L1.3125 6.18749L6.375 1.12499Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit-2.5b8fbfdb.svg";
export { ForwardRef as ReactComponent };